<!-- eslint-disable vue/no-parsing-error -->
<template>
    <div>
        <div>
            <b-card no-body class="col-md-12 p-1">
                <div class="row">
                    <div class="col-md-12 mb-2">
                        <div class="row">
                            <div class="col-md-6">
                                <h3>Top 10 User Clicked</h3>
                            </div>
                            <div class="col-md-6">
                                <button class="btn btn-primary float-right" @click="exportTopTen">
                                    Export Top 10 User
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="table-responsive-sm" style="overflow-x: auto">
                            <table class="table b-table table-fixed">
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Name</th>
                                        <th>Nama Toko</th>
                                        <th>Click Counter</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="isLoadingTracker">
                                        <td colspan="5" class="text-center">
                                        <b-spinner label="Loading..." variant="primary" />
                                        </td>
                                    </tr>
                                    <tr v-for="(item, key) in adsCounter" :key="key" v-if="!isLoadingTracker">
                                        <td>{{ key + 1 }}</td>
                                        <td>{{ item.user_name }}</td>
                                        <td>{{ item.merchant_name }}</td>
                                        <td>{{ item.total_click }}</td>
                                    </tr>
                                    <tr v-if="adsCounter.length == 0 && !isLoadingTracker">
                                        <td colspan="5" class="text-center">
                                            Data is empty.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="row mt-1">
                                <div class="col-6 pl-2">
                                    <small>Showing 1 to 10 from {{ adsCounter.length }}</small>
                                </div>
                                <div class="col-6 pr-2" />
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>
        </div>

        <div>
            <b-card no-body class="col-md-12 p-1">
                <div class="row">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input v-model="filter.search" type="text" class="form-control" placeholder="Search...">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <button class="btn btn-primary float-right" @click="exportListUser">
                                    Export List User
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="col-md-2 ml-auto">
                            <div class="form-group">
                                <select v-model="perPage" class="form-control">
                                    <option :value="30">30</option>
                                    <option :value="40">50</option>
                                    <option :value="100">100</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class=" col-md-12">
                        <h3>List User</h3>
                    </div>

                    <div class="col-md-12">
                        <div class="table-responsive-sm" style="overflow-x: auto">
                            <table class="table b-table table-fixed">
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Name</th>
                                        <th>Nama Toko</th>
                                        <th>IP</th>
                                        <th>Time Click</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="isLoading">
                                        <td colspan="5" class="text-center">
                                        <b-spinner label="Loading..." variant="primary" />
                                        </td>
                                    </tr>
                                    <tr v-for="(item, key) in result.data" :key="key" v-if="!isLoading">
                                        <td>{{ (result.from || 0) + key }}</td>
                                        <td>{{ item.user_name }}</td>
                                        <td>{{ item.merchant_name }}</td>
                                        <td>{{ item.user_ip }}</td>
                                        <td>{{ item.created_at }}</td>
                                    </tr>
                                    <tr v-if="result.data.length == 0 && !isLoading">
                                        <td colspan="5" class="text-center">
                                            Data is empty.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="row mt-1">
                                <div class="col-6 pl-2">
                                    <small>Showing {{ result.from || 0 }} to {{ result.to || 0 }} from {{ result.total || 0 }}</small>
                                </div>
                                <div class="col-6 pr-2">
                                    <pagination
                                        :data="result"
                                        :limit="4"
                                        align="right"
                                        @pagination-change-page="page => getData(page)"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import { BCard, BSpinner } from 'bootstrap-vue'
    import { checkPermission, successNotification, errorNotification } from '@/auth/utils'
    import Vue from 'vue'
    import VuejsDialog from 'vuejs-dialog'
    import moment from 'moment'
    import FileSaver from 'file-saver'

    import 'vuejs-dialog/dist/vuejs-dialog.min.css'

    Vue.use(VuejsDialog)

    export default {
        components: {
            BCard,
            BSpinner,
        },
        props: {
        },
        title() {
            return 'Detail Ads'
        },
        watch: {
            filter: {
                handler: _.debounce(function () {
                    this.getData()
                }, 300),
                deep: true,
            },
            perPage() {
                this.getData()
            },
        },
        setup(props) {
            return {
                checkPermission,
                successNotification,
                errorNotification,
            }
        },
        data() {
            return {
                currentPage: 1,
                result: {
                    data: [],
                },
                perPage: 30,
                isLoadingTracker: false,
                isLoading: false,
                isLoadingImport: false,
                isLoadingExport: false,
                detailAds: null,
                adsCounter: [],
                imageId: null,
                filter: {
                    search: '',
                },
            }
        },
        mounted() {
            this.imageId = this.$route.params.id
            this.getAdsDetail()
            this.getData()
        },
        methods: {
            getAdsDetail() {
                this.isLoadingTracker = true
                this.$http.post('/super-admin/ads/grouping-ads-clicker', {
                    image_id: this.imageId,
                }).then(response => {
                    this.detailAds = response.data.data?.image
                    this.adsCounter = response.data.data?.counter
                    this.isLoadingTracker = false
                })
            },
            getData(page = 1) {
                this.isLoading = true
                this.currentPage = page
                this.$http.post('/super-admin/ads/get-detail-ads', {
                    image_id: this.imageId,
                    page: this.currentPage,
                    per_page: this.perPage,
                    search: this.filter.search,
                }).then(response => {
                    this.result = response.data.data
                    this.isLoading = false
                }).catch(() => {
                    this.isLoading = false
                })
            },
            async exportTopTen() {
                const response = await this.$http.post(
                    '/super-admin/ads/export-top-ten',
                    {
                        image_id: this.imageId,
                    },
                    {
                        responseType: 'blob',
                    },
                )

                const dateDownload = new Date()
                const timestamp = moment(dateDownload).format('YYYYMMDD')
                let fileName = ''
                fileName = `top-10-user-ads-id-${this.imageId}-${timestamp}.xlsx`
                FileSaver.saveAs(response.data, fileName)
            },
            async exportListUser() {
                const response = await this.$http.post(
                    '/super-admin/ads/export-list-user',
                    {
                        image_id: this.imageId,
                    },
                    {
                        responseType: 'blob',
                    },
                )

                const dateDownload = new Date()
                const timestamp = moment(dateDownload).format('YYYYMMDD')
                let fileName = ''
                fileName = `list-user-ads-id-${this.imageId}-${timestamp}.xlsx`
                FileSaver.saveAs(response.data, fileName)
            },
        },
    }
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
